import { STATUS } from 'straightline-utils/constants';

export const STATUS_COLORS = {
  [STATUS.BOOKED]: 'secondary',
  [STATUS.MATCHED]: 'info',
  [STATUS.DISPATCHED]: 'primary',
  [STATUS.PICKUP]: 'primary',
  [STATUS.TRANSIT]: 'primary',
  [STATUS.DELIVERY]: 'primary',
  [STATUS.DELIVERED]: 'success',
  [STATUS.CANCELLED]: 'danger'
};
